import React from "react"

import PropTypes from "prop-types"

import * as styles from "./sticky-intro.module.scss"

const StickyIntro = ({ children }) => (
  <div>
    <div className={styles.intro}>{children}</div>
  </div>
)
export default StickyIntro

StickyIntro.propTypes = {
  children: PropTypes.node.isRequired,
}
